
import { mapActions, mapGetters } from "vuex";
import AOS from 'aos'
import 'aos/dist/aos.css'
export default {
	computed: {
		...mapGetters({
			settings: 'settings/settings/settings'
		}),
		benefits_alternative(){
			return [
				{
					text: `Скидка в кредит <br/> ${this.settings.sale_credit}₽`,
					icon: require('~/assets/icons/bwb6.svg'),
					description:`При оформлении автомобиля в кредит Вам предоставляется дополнительно скидка от изначальной стоимости ${this.settings.sale_credit} ₽`
				},
				{
					text: `Первый взнос от ${this.settings.first_installment}`,
					icon: require('~/assets/icons/bwb1.svg'),
					description:'При покупке авто в рассрочку первоначальный взнос 0% на весь ассортимент авто'
				},
				{
					text: `Гарантия 1 год`,
					icon: require('~/assets/icons/bwb7.svg'),
					description:'Мы предоставляем гарантию на техническое состояние автомобиля в течение одного года с момента покупки.'
				},
				{
					text: "Trade-In как первый взнос",
					icon: require('~/assets/icons/bwb3.svg'),
					description:`В качестве первоначального взноса Вы можете сдать свой автомобиль по системе Trade-In с дополнительной скидкой ${this.settings.sale_tradein} ₽`
				},
				{
					text: `Одобрение по 2-м документам`,
					icon: require('~/assets/icons/bwb8.svg'),
					description:'При покупке автомобиля в кредит Вам потребуется только паспорт и водительское удостоверение.'
				},
				{
					text: "Комплект шин в подарок",
					icon: require('~/assets/icons/bwb5.svg'),
					description:'При покупке автомобиля в АвтоЭксперт каждый клиент получает второй комплект резины в подарок'
				},
			]
		}
	},
	props: {
		benefits: Array,
		hasModal: {
			type: Boolean,
			default: true
		},
		modal: {
			type: Boolean,
			default: false
		},
		position: {
			type: String,
			default: 'static'
		},
		catalog: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		...mapActions({
			openBenefit: 'benefits/openBenefit'
		})
	},


	mounted() {
		new swiper.default('.swiper--benefits.swiper', {
			modules: [swiper.Navigation, swiper.Autoplay],
			loop: false,
			// autoplayDisableOnInteraction: true,
			autoplay: false,
			initialSlide: 0,
			// centeredSlides: true,
			watchSlidesProgress: true,
			// centeredSlidesBounds:true,
			// roundLengths: true,

			// centerInsufficientSlides:true,
			// slidesOffsetAfter: this.$refs.asd.getBoundingClientRect().left,
			// cssMode:true,
			breakpoints: {
				// when window width is >= 320px
				220: {
					slidesPerView: 1.5,
					spaceBetween: 20
				},
				600: {
					slidesPerView: 3,
					spaceBetween: 24,
					// slidesOffsetBefore: leftPadding,

				}

			},
			navigation: {
				nextEl: '.catalog__list .swiper-button-next',
				prevEl: '.catalog__list .swiper-button-prev',
			},
		});
	},
}
